module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_5_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_5_before_tn.jpg
// module id = 1670
// module chunks = 0